var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.88,
    height: 32.641,
    viewBox: "0 0 37.88 32.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_93496",
    "data-name": "Path 93496",
    d: "M-824.765,63.513l2.579-5.059c-.3-.154-.572-.294-.845-.441a15.558,15.558,0,0,1-6.8-6.533,11.838,11.838,0,0,1,.86-12.849,16.129,16.129,0,0,1,7.526-5.889,22.78,22.78,0,0,1,20.278,1.082,14.5,14.5,0,0,1,6.665,7.117,11.882,11.882,0,0,1-1.735,12.533,17.808,17.808,0,0,1-9.051,6.069,22.392,22.392,0,0,1-9.336.959,1.587,1.587,0,0,0-.614.087q-4.479,1.378-8.955,2.769C-824.345,63.407-824.506,63.443-824.765,63.513Zm3.749-19.607a1.738,1.738,0,0,0-1.794,1.781,1.775,1.775,0,0,0,1.79,1.8,1.813,1.813,0,0,0,1.828-1.815A1.78,1.78,0,0,0-821.016,43.906Zm8.763,0a1.758,1.758,0,0,0-1.822,1.761,1.8,1.8,0,0,0,1.819,1.818,1.791,1.791,0,0,0,1.8-1.8A1.749,1.749,0,0,0-812.253,43.907Zm8.787,0a1.786,1.786,0,0,0-1.832,1.765,1.82,1.82,0,0,0,1.794,1.815,1.817,1.817,0,0,0,1.83-1.776A1.777,1.777,0,0,0-803.466,43.906Z",
    transform: "translate(831.323 -30.872)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.e5cf15df74bf8d315f68eb8049ef206c.svg";
export { ForwardRef as ReactComponent };